import { ENV } from "@/enum/system";

import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface AdjustConfig extends SDKConfig {
  appToken: string;
}

export class AdjustSDK extends BaseSDK {
  constructor(config: AdjustConfig) {
    super(SDKName.AdjustSDK, config);
  }

  async initialize(): Promise<void> {
    const config = this.config as AdjustConfig;
  }

  private initializeAdjust(): void {
    // Initialize Adjust with GPS ADID
    const config = this.config as AdjustConfig;

    // Add Adjust initialization logic here
  }

  reportEvent(event: string, data: Record<string, unknown>): void {
    //处理事件上报
  }
}
